module.exports = __webpack_public_path__ + "assets/img/53262cb98866c05cd097f3901b2520d6.png";